export default function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_complement.js
// module id = Qnkw
// module chunks = 0